<template>
  <drag-modal :visible="visible" @cancel="reset" :title="title" width="860px">
    <div class="hisform">
      <a-form-model ref="forms" :model="form" :rules="rules" :label-col="{ span: 3 }" :wrapper-col="{ span: 7 }">
        <a-form-model-item label="我方人员" prop="uname">
          <a-input v-model="form.uname" :disabled="see" disabled />
        </a-form-model-item>
        <a-form-model-item label="对方人员" prop="adversary">
          <a-input v-model="form.adversary" :disabled="see" />
        </a-form-model-item>
        <a-form-model-item label="备注信息" prop="content" :wrapper-col="{ span: 21 }">
          <Textarea :content="comment" @contentVal="reContent" :more="false" :edit="see" :keyArr="['content_time', 'content_user']"></Textarea>
        </a-form-model-item>
        <a-form-model-item label="沟通方式" prop="type">
          <a-select placeholder="请选择沟通方式" v-model="form.type" :disabled="see">
            <a-select-option :value="i.value" v-for="(i, index) in typeList" :key="index">
              {{ i.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="沟通类型" prop="connect_type">
        
          <a-select placeholder="请选择沟通类型" v-model="form.connect_type" :disabled="see">
            <a-select-option :value="1">  {{$store.state.cause.cause_type==1?'判决前沟通':'调解沟通'}}</a-select-option>
            <a-select-option :value="2">执行前沟通</a-select-option>
            <a-select-option :value="3">执行后沟通</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="type">
          <a-input type="text" v-model="form.type_remark" placeholder="请输入" :disabled="see"></a-input>
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 24 }" style="margin-top: 20px">
          <Upload :fList="List" @upFileAfter="lisUpload" :isHis="1" v-if="clear != 1" :Wid="'102px'" :edit="see" />
        </a-form-model-item>
        <a-form-model-item :wrapper-col="{ span: 16, offset: 6 }" v-if="!see">
          <a-popconfirm title="确认提交此条数据吗?" ok-text="确定" cancel-text="取消" @confirm="sub">
            <a-button type="primary" style="width: 148px"> 保存 </a-button>
          </a-popconfirm>
          <a-button style="margin-left: 20px; width: 148px; background: #b2c9e1; color: #fff;" @click="reset">取消</a-button>
        </a-form-model-item>
      </a-form-model>
    </div>
  </drag-modal>
</template>

<script>
  import {
    commentAdd,
    commentEdit
  } from '@/server/debtor'
  import Upload from '@/components/uploads'
  import Textarea from '@/components/textarea'
  export default {
    name:"His",
    components: {
      Upload,
      Textarea
    },
    props: {
      info: {
        type: Object,
        default () {
          return {}
        },
      },
      clear: {
        type: Number,
        default () {
          return 0
        },
      },
    },
    watch: {
      info: {
        handler(newVal) {
          if (newVal.id) {
            this.form = {
              id: newVal.id,
              uname: newVal.uname,
          //    uname:this.$store.state.user.uname,
              adversary: newVal.adversary,
              connect_type: newVal.connect_type,
              content: newVal.content,
              content_user: newVal.content_user,
              content_time: newVal.content_time,
              type: newVal.type,
              type_remark: newVal.type_remark,
            }
            this.comment = [{
              content: newVal.content,
              content_user: newVal.content_user,
              content_time: newVal.content_time,
            }, ]
            newVal.files.map((ele) => {
              ele.title = ele.origin_name
              ele.upload_id = ele.id
            })
            this.file = newVal.files.map((ele) => {
              return ele.id
            })
            this.List = newVal.files
            this.see = newVal.see
            this.title = newVal.see ? '查看案件沟通记录' : '修改案件沟通记录'
          } else {
            this.comment = [{
              content: '',
              content_user: '',
              content_time: ''
            }]
            this.List = []
            this.file = []
            this.form = {}
            this.form.uname = this.$store.state.user.uname;
            this.see = false
            this.title = '新增案件沟通记录'
          }
        },
        immediate: true,
      },
    },
    data() {
      return {
        List: [],
        comment: [],
        title: '新增案件沟通记录',
        typeList: [{
            name: '未选择',
            value: 0
          },
          {
            name: '现场',
            value: 1
          },
          {
            name: '电话',
            value: 2
          },
          {
            name: '短信',
            value: 3
          },
          {
            name: '微信',
            value: 4
          },
        ],
        form: {},
        see: false,
        file: [],
        rules: {
          connect_type: [{
            required: true,
            message: '请选择沟通类型',
            trigger: 'change'
          }, ],
          type: [{
            required: true,
            message: '请选择沟通方式',
            trigger: 'change'
          }, ],
          uname: [{
            required: true,
            message: '请输入我方人员',
            trigger: 'blur'
          }],
          adversary: [{
            required: true,
            trigger: 'blur',
            message: '请输入对方人员'
          }, ],
          content: [{
            required: true,
            trigger: 'blur',
            message: '请输入备注信息'
          }, ],
        },
        visible: false,
      }
    },
    methods: {
      reContent(val) {
        this.form.content = val[0].content
        this.form.content_user = val[0].content_user
        this.form.content_time = val[0].content_time
      },
      lisUpload(fileList) {
        this.file = fileList
      },
      sub() {
        let form = JSON.parse(JSON.stringify(this.form))
        form.files = this.file
        form.cause_id = this.$store.state.cause.id
        
        if (form.id) {
          commentEdit(form).then((e) => {
            this.$message.success({
              content: '修改成功',
              key: 'updatable'
            })
            this.$store.dispatch('Case/getlist', {
              debtor_id: this.$route.params.id,
            })
            this.reset()
            this.$emit('resh',2)
          })
        } else {
          commentAdd(form).then((e) => {
            this.$message.success({
              content: '新增成功',
              key: 'updatable'
            })
            this.$store.dispatch('Case/getlist', {
              debtor_id: this.$route.params.id,
            })
            this.reset()
            this.$emit('resh')
          })
        }
      },
      reset() {
        this.$refs.forms.resetFields()
        // this.$store.dispatch('openkey', {
        //   key: 'His',
        //   by: false
        // })
        this.visible=false
      },
    },
  }
</script>

<style lang="less">
  .hisform {
    textarea {
      width: 100%;
      height: 80px;
      border: 1px solid #efefef;
      padding: 4px 10px;
    }
  }
</style>
